// extracted by mini-css-extract-plugin
module.exports = {"FiltersTitle":"_1VDQW","PriceInputs":"Pm0mw","PriceInput":"_2eqWt","LanguageInput":"_37ZjJ","LanguageInputExpanded":"uHnd7","EmptyStateText":"_20fK1"};